// extracted by mini-css-extract-plugin
export default {"button":"mY_lx","noNextRecord":"mY_mZ","footerContainer":"mY_m0"};